import React from "react"
import RowMenu from "./RowMenu"
import clsx from "clsx"
import PageBuilderConstants from "./constants/PageBuilderConstants"
import Column from "./Column"
import ResizeHandle from "./ResizeHandle"

class Row extends React.Component {

  constructor(props) {
    super(props);
  }

  /**
  * Determines if this row's columns have content
  * If any column has content, the entire row is considered to have content
  *
  * @returns {Boolean}
  */
  hasContent() {
    var self = this;

    for(var id in self.props.columns) {
      if (self.props.columns[id].content !== '' || self.props.columns[id].content_type) {
        return true;
      }
    }

    return false;
  }

  /**
  * Determines if this row is currently active
  *
  * @returns {Boolean}
  */
  isActive() {
    return this.props.id === this.props.activeRowId;
  }

  /**
  * Determines if this row is currently being resizing
  *
  * @returns {Boolean}
  */
  isResizing() {
    return this.props.id === this.props.resizeRowId;
  }

  /**
  * Determines if this row is currently disabled
  *
  * @returns {Boolean}
  */
  isDisabled() {
    return !this.isActive() && !this.isResizing() && (this.props.activeRowId !== null || this.props.resizeRowId !== null);
  }

  render() {
    var self = this;

    var rowClasses = clsx({
      row: true,
      disabled: this.isDisabled(),
      resizing: this.isResizing(),
      hidden: (this.props.mode !== PageBuilderConstants.COMPOSE && !this.hasContent()),
      highlight: this.props.highlightRowId === this.props.id,
      'hide-on-desktop': typeof this.props.hideOnDevice !== 'undefined' && this.props.hideOnDevice[PageBuilderConstants.DESKTOP],
      'hide-on-tablet': typeof this.props.hideOnDevice !== 'undefined' && this.props.hideOnDevice[PageBuilderConstants.TABLET],
      'hide-on-phone': typeof this.props.hideOnDevice !== 'undefined' && this.props.hideOnDevice[PageBuilderConstants.PHONE]
    });


    var columns = [];

    var props = {
      mode: this.props.mode,
      accommodations: this.props.accommodations,
      forms: this.props.forms,
      textVariables: this.props.textVariables,
      rowId: this.props.id,
      pageBuilderMounted: this.props.pageBuilderMounted,
      activeRowId: this.props.activeRowId,
      activeColumnId: this.props.activeColumnId,
      highlightColumnId: this.props.highlightColumnId,
      openMenuRowId: this.props.openMenuRowId,
      resizeRowId: this.props.resizeRowId,
      forceUpdate: this.props.forceUpdate
    }

    for(var i = 0, ilen = self.props.columns.length; i < ilen; i++) {
      var column = self.props.columns[i];
      columns.push(<Column {...props} {...self.props} key={column.id} id={column.id} size={column.size} content={column.content} contentType={column.content_type} style={column.style} widget_id={column.widget_id} chart_id={column.chart_id} />);
    }

    // build resize handles
    if (this.isResizing()) {
      var resizeHandles = [];

      for (var i = 0, ilen = self.props.columns.length; i < ilen; i++) {
        var column = self.props.columns[i];

        var nextColumn = self.props.columns[i + 1];

        if (nextColumn && column.id !== nextColumn.id && (column.size > 1 || nextColumn.size > 1)) {
          resizeHandles.push(<ResizeHandle key={column.id + nextColumn.id} rowId={this.props.id} leftColumn={column} rightColumn={nextColumn} columns={self.props.columns} gridSize={75} handleSize={5} />)
        }
      }
    }
    
    return (
      <div id={this.props.id} className={rowClasses}>
       {
         this.props.mode === 'compose'
         ?
         <RowMenu {...props} {...self.props} columnCount={self.props.columns.length} hideOnDevice={this.props.hideOnDevice} />
        :
        null
       } 
        {this.props.resizeRowId === this.props.id ? resizeHandles : null}
        {columns}
      </div>
    );
  }

};

export default Row
